import { render, staticRenderFns } from "./ajax-form.vue?vue&type=template&id=58566f86&scoped=true&"
import script from "./ajax-form.vue?vue&type=script&lang=js&"
export * from "./ajax-form.vue?vue&type=script&lang=js&"
import style0 from "./ajax-form.vue?vue&type=style&index=0&id=58566f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58566f86",
  null
  
)

export default component.exports